"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../util");
var app_name_1 = require("../constant/app-name");
var UNKNOWN = 'unknown';
var envMap = {
    'daijia.driver': app_name_1.appName.daijia,
    'kflower.passenger': app_name_1.appName.kflowerPassenger,
    'kflower.driver': app_name_1.appName.kflowerDriver,
    'kflowerudriver': app_name_1.appName.kflowerDriver,
    'didi.passenger.global': app_name_1.appName.globalPassenger,
    '_ddudriver_': app_name_1.appName.driver,
    'didigsui': app_name_1.appName.driver,
    'didi.driver': app_name_1.appName.globalDriver,
    'didi.idriver': app_name_1.appName.globalDriver,
    'didi.blord': app_name_1.appName.shunfengche,
    'didi.psnger': app_name_1.appName.shunfengche,
    'didi.psclient': app_name_1.appName.qingjuchelian,
    'freight.driver': app_name_1.appName.driverFreight
};
exports.app = {};
function initApp(bridge) {
    var appRE = /didi\.(\w+)[\s\/]([\d\.]+)/;
    var daijiaAppREG = /(daijia\.\w+)[\s\/]([\d\.]+)/ig;
    var financeAppREG = /(finance\.\w+)[\s\/]([\d\.]+)/ig;
    var didiesAppREG = /(didies)[\s\/]([\d\.]+)/ig;
    var xiaojuchefuAppREG = /(xiaojuchefu)[\s\/]([\d\.]+)/ig;
    var kfloweruDriverAppREG = /(kflower[\.|u]driver).+\_([\d\.]+)/ig;
    var kflowerPassengerAppREG = /(kflower\.passenger)\/([\d\.]+)/ig;
    var globalPassengerAppREG = /(didi\.passenger\.global)\/([\d\.]+)/ig;
    var driverIOSAppREG = /(\_ddudriver\_).*_(\d+\.\d+\.\d+).*/ig;
    var driverAndroidAppREG = /(didigsui).*_(\d+\.\d+\.\d+)_.*/ig;
    var globalDriverAndroidAppREG = /(didi.driver).*[\/]([\d\.]+)/ig;
    var globalDriverIOSAppREG = /(didi.idriver).*\_[\d\.]+\_([\d\.]+)/ig;
    var shunfengcheAppREG = /(didi.(blord|psnger)).*[\/]([\d\.]+)/ig;
    var qingjuchelianAppREG = /(didi.psclient)[\/]([\d\.]+)/ig;
    var driverFreightAppREG = /(freight.driver)[\/]([\d\.]+)/ig;
    var weixinAppREG = /MicroMessenger/ig;
    var alipayAppREG = /AlipayClient/ig;
    var matches = daijiaAppREG.exec(util_1.UA) ||
        financeAppREG.exec(util_1.UA) ||
        didiesAppREG.exec(util_1.UA) ||
        xiaojuchefuAppREG.exec(util_1.UA) ||
        kfloweruDriverAppREG.exec(util_1.UA) ||
        kflowerPassengerAppREG.exec(util_1.UA) ||
        globalPassengerAppREG.exec(util_1.UA) ||
        globalDriverIOSAppREG.exec(util_1.UA) ||
        globalDriverAndroidAppREG.exec(util_1.UA) ||
        driverIOSAppREG.exec(util_1.UA) ||
        driverAndroidAppREG.exec(util_1.UA) ||
        shunfengcheAppREG.exec(util_1.UA) ||
        qingjuchelianAppREG.exec(util_1.UA) ||
        driverFreightAppREG.exec(util_1.UA) ||
        util_1.UA.match(appRE);
    var weixinMatch = weixinAppREG.exec(util_1.UA);
    var alipayMatch = alipayAppREG.exec(util_1.UA);
    var env = UNKNOWN;
    var version = UNKNOWN;
    if (matches) {
        env = matches[1];
        version = matches[2];
        env = envMap[env] || env;
    }
    else if (weixinMatch) {
        env = app_name_1.otherName.weixin;
    }
    else if (alipayMatch) {
        env = app_name_1.otherName.alipay;
    }
    var system = util_1.isIOS ? 'ios' : util_1.isAndroid ? 'android' : UNKNOWN;
    var sysVersion = util_1.isIOS ? util_1.iosVersion : util_1.isAndroid ? util_1.androidVersion : UNKNOWN;
    bridge.app = exports.app = {
        env: env,
        version: version,
        system: system,
        sysVersion: sysVersion,
        isFusion: util_1.isFusion,
        driver: env === app_name_1.appName.driver
    };
}
exports.initApp = initApp;
function compareAppVersion() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    switch (args.length) {
        case 2:
            return compare(exports.app.version || '', args[0], args[1]);
        case 3:
            return compare.apply(null, args);
        default:
            return false;
    }
}
exports.compareAppVersion = compareAppVersion;
function compareSysVersion() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    switch (args.length) {
        case 2:
            return compare(exports.app.sysVersion || '', args[0], args[1]);
        case 3:
            return compare.apply(null, args);
        default:
            return false;
    }
}
exports.compareSysVersion = compareSysVersion;
function compare(v1, symbol, v2) {
    var _v1 = parse(v1);
    var _v2 = parse(v2);
    if (symbol.indexOf('=') !== -1 && _v1 === _v2) {
        return true;
    }
    if (symbol.indexOf('>') !== -1 && _v1 > _v2) {
        return true;
    }
    if (symbol.indexOf('<') !== -1 && _v1 < _v2) {
        return true;
    }
    return false;
}
function parse(version) {
    if (version === void 0) { version = ''; }
    var parts = version.split('.');
    parts.length = 4;
    var ret = [];
    util_1.each(parts, function (n) {
        n = n * 1;
        if (n) {
            ret.push(n >= 10 ? n : '0' + n);
        }
        else {
            ret.push('00');
        }
    });
    return parseInt(ret.join(''), 10);
}
